import request from 'superagent'
import isEmpty from 'lodash/isEmpty'

import {
    FLOWERAI_CLOUD_PLANT,
    FLOWERAI_CLOUD_PLANT_LIST
} from '../constants/urls'

export const GET_PLANT = 'GET_PLANT'
export function getPlant(id, language = 'de-DE') {
    const req = request
        .get(FLOWERAI_CLOUD_PLANT.replace(':id', id))
        .query({
            country: language,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_PLANT,
        payload: req,
    }
}

export const LOADING_PLANT_LIST = 'LOADING_PLANT_LIST'
export function loadPlantList() {
    return {
        type: LOADING_PLANT_LIST,
        payload: true,
    }
}

export const GET_PLANT_LIST = 'GET_PLANT_LIST'
export function getPlantList(page = 1, language = 'de-DE') {
    const req = request
        .get(FLOWERAI_CLOUD_PLANT_LIST)
        .query({
            country: language,
            page,
            limit: 20,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_PLANT_LIST,
        payload: req,
    }
}

export const SET_FAVORITE_PLANT = 'SET_FAVORITE_PLANT'
export function setFavoritePlant(id) {
    return {
        type: SET_FAVORITE_PLANT,
        payload: id,
    }
}

export const TOGGLE_SEARCH_PLANT = 'TOGGLE_SEARCH_PLANT'
export function togglePlantSearch(active) {
    return {
        type: TOGGLE_SEARCH_PLANT,
        payload: active,
    }
}

export const TOGGLE_FILTER_PLANT = 'TOGGLE_FILTER_PLANT'
export function togglePlantFilter(name, active) {
    return {
        type: TOGGLE_FILTER_PLANT,
        payload: {
            active,
            name,
        },
    }
}

export const CHANGE_SEARCH_QUERY = 'CHANGE_SEARCH_QUERY'
export function changeSearchQuery(searchQuery) {
    return {
        type: CHANGE_SEARCH_QUERY,
        payload: searchQuery,
    }
}

export const LOADING_PLANT_SEARCH = 'LOADING_PLANT_SEARCH'
export function loadPlantSearch() {
    return {
        type: LOADING_PLANT_SEARCH,
        payload: true,
    }
}

export const SEARCH_PLANT = 'SEARCH_PLANT'
export const RESET_SEARCH_PLANT = 'RESET_SEARCH_PLANT'
export function searchPlant(searchQuery, page = 1, language = 'de-DE') {
    if (isEmpty(searchQuery)) {
        return {
            type: RESET_SEARCH_PLANT,
            payload: null,
        }
    }

    const req = request
        .get(FLOWERAI_CLOUD_PLANT_LIST)
        .query({
            country: language,
            search: searchQuery,
            page,
            limit: 20,
        })
        .auth('admin', 'supersecret')

    return {
        type: SEARCH_PLANT,
        payload: req,
        meta: {
            searchQuery,
        },
    }
}



// WEBPACK FOOTER //
// ./src/actions/plants.js